import { Card, CardContent } from "@repo/ui";
import { categorieColors } from "@repo/utils";

interface InbasketEvalRow {
  _id: string;
  parcoursId: string;
  nomCandidat?: string;
  prenomCandidat?: string;
  clientResultsJson?: string;
  clientResultsGradesJson?: string;
}

interface InbasketCampagneTableProps {
  evaluations: InbasketEvalRow[];
}

export function InbasketCampagneTable({ evaluations }: InbasketCampagneTableProps) {
  const parsedRows = evaluations.map((eval_) => ({
    ...eval_,
    clientResults: eval_.clientResultsJson
      ? (JSON.parse(eval_.clientResultsJson) as Record<string, number>)
      : undefined,
    clientResultsGrades: eval_.clientResultsGradesJson
      ? (JSON.parse(eval_.clientResultsGradesJson) as Record<string, string>)
      : undefined,
  }));

  // Collect all unique competency names from all candidates
  const competences: string[] = [];
  const seen = new Set<string>();
  for (const row of parsedRows) {
    if (row.clientResults) {
      for (const key of Object.keys(row.clientResults)) {
        if (!seen.has(key)) {
          seen.add(key);
          competences.push(key);
        }
      }
    }
  }

  if (evaluations.length === 0) {
    return (
      <Card>
        <CardContent className="py-8 text-center">
          <p className="text-muted-foreground">
            Aucune évaluation inbasket dans cette campagne.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border bg-muted/30">
                <th className="px-4 py-3 text-left font-medium text-muted-foreground whitespace-nowrap">
                  Candidat
                </th>
                {competences.map((comp) => (
                  <th
                    key={comp}
                    className="px-3 py-3 text-center font-medium text-muted-foreground whitespace-nowrap"
                  >
                    {comp}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {parsedRows.map((eval_) => (
                <tr
                  key={eval_._id}
                  className="border-t border-border hover:bg-muted/20 transition-colors"
                >
                  <td className="px-4 py-3 font-medium whitespace-nowrap">
                    {eval_.prenomCandidat || eval_.nomCandidat
                      ? `${eval_.prenomCandidat ?? ""} ${eval_.nomCandidat ?? ""}`.trim()
                      : <span className="text-muted-foreground italic">Anonyme</span>
                    }
                  </td>
                  {competences.map((comp) => {
                    const score = eval_.clientResults?.[comp];
                    const grade = eval_.clientResultsGrades?.[comp];
                    const color = grade ? (categorieColors[grade] ?? "#6b7280") : undefined;

                    return (
                      <td key={comp} className="px-3 py-3 text-center">
                        {score !== undefined && color ? (
                          <span
                            className="inline-block rounded px-2 py-0.5 text-xs font-semibold text-white tabular-nums"
                            style={{ backgroundColor: color }}
                          >
                            {score.toFixed(2)}%
                          </span>
                        ) : (
                          <span className="text-muted-foreground">—</span>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
